const { analyticsEventCenter, ANALYTICS_EVENTS } = require('../../events');
const { createCustomEventGA4 } = require('../models/customEventGA4');
const pushEvent = require('../pushEvent');

/* -------------------------------------------------------------------------- *\
 * LOGIN EVENTS                                                               *
 * - Forgot password
 * - Tooltip
\* -------------------------------------------------------------------------- */

/**
 * Subscribe to our analytics events and push to dataLayers
 */
function subscribeToAnalyticsEvents() {
  // Forgot password form in login page
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.loginForgotPasswordOpened, () => {
    pushEvent(
      createCustomEventGA4('login_forgot_password', [
        ['action', 'open'],
      ]),
    );
  });
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.loginForgotPasswordSent, () => {
    pushEvent(
      createCustomEventGA4('login_forgot_password', [
        ['action', 'send'],
      ]),
    );
  });
  // Tooltip shown after add to cart when not logged
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.loginTooltipClosed, () => {
    pushEvent(
      createCustomEventGA4('login_tooltip', [
        ['action', 'close'],
      ]),
    );
  });
  analyticsEventCenter.subscribe(ANALYTICS_EVENTS.loginTooltipOpened, () => {
    pushEvent(
      createCustomEventGA4('login_tooltip', [
        ['action', 'impression'],
      ]),
    );
  });
}

module.exports = {
  subscribeToAnalyticsEvents,
};
